function latLngsToLngLats(latLngs) {

    return latLngs.map(latLng => [latLng[1], latLng[0]]);

}

export default latLngsToLngLats;
